import RestService from '../services/rest';


async function sendProductFeedback(
  clientId, userId, productSoneparId, websiteReview, productFeedbackReasonId, feedback,
) {
  return RestService.postAuthenticated('productFeedback/send', {
    clientId,
    userId,
    productSoneparId,
    feedback,
    websiteReview,
    productFeedbackReasonId,
  });
}

export default {
  sendProductFeedback,
};
